import type { RootState } from '../types';

const EMPTY_ARRAY: readonly never[] = [];
const EMPTY_OBJECT: Record<string, never> = {};

export const carriersSelectors = {
  basicList: (state: RootState) => state.carriers.basicCarriers || EMPTY_ARRAY,
  basicAccountsList: (state: RootState) =>
    state.carriers.basicCarrierAccounts || EMPTY_ARRAY,
  basicCarrierCompanies: (state: RootState) =>
    state.carriers.basicCarrierCompanies || EMPTY_ARRAY,
  carrierPackageTypes: (state: RootState) =>
    state.carriers.carrierPackageTypes || EMPTY_OBJECT,
};
